"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STOREFRONT_PRODUCTS_HASH_OPTIONS = void 0;
exports.collectSectionProductLinkHashes = collectSectionProductLinkHashes;
const apiTypes_1 = require("../apiTypes");
const DEFAULT_OPTIONS = {};
function shouldIncludeLinkHash(linkHash, options) {
    if (options.excludeHighlightedProductHash &&
        linkHash === apiTypes_1.HIGHLIGHTED_PRODUCT_HASH) {
        return false;
    }
    return Boolean(linkHash);
}
function isStaticPlpSection(section) {
    return section.type === apiTypes_1.ApiSectionType.PLP && !section.productGridType;
}
function collectSectionProductLinkHashes(sections, options = DEFAULT_OPTIONS, floatingButtonLinkHash) {
    const hashes = [];
    for (const section of sections) {
        if ('linkHash' in section && section.linkHash) {
            if (shouldIncludeLinkHash(section.linkHash, options)) {
                hashes.push(section.linkHash);
            }
        }
        if ('linkHashes' in section && section.linkHashes) {
            for (const hash of section.linkHashes) {
                if (shouldIncludeLinkHash(hash, options)) {
                    hashes.push(hash);
                }
            }
        }
        if ('visibleProducts' in section && section.visibleProducts) {
            const includeVisibleProducts = !options.excludeDynamicPlpVisibleProducts ||
                isStaticPlpSection(section);
            if (includeVisibleProducts) {
                for (const hash of section.visibleProducts) {
                    if (shouldIncludeLinkHash(hash, options)) {
                        hashes.push(hash);
                    }
                }
            }
        }
    }
    if (floatingButtonLinkHash &&
        shouldIncludeLinkHash(floatingButtonLinkHash, options)) {
        hashes.push(floatingButtonLinkHash);
    }
    return Array.from(new Set(hashes));
}
exports.STOREFRONT_PRODUCTS_HASH_OPTIONS = {
    excludeHighlightedProductHash: true,
    excludeDynamicPlpVisibleProducts: true,
};
